import { Suspense } from "react";

import { Loader } from "@braintrust/braintrust-ui-components";

import { CreateBulkOffersContentLazy } from "./lazy";

export const CreateBulkOffersPage = () => {
  return (
    <Suspense fallback={<Loader centered />}>
      <CreateBulkOffersContentLazy />
    </Suspense>
  );
};
